import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { pageInitSize } from "utils/HelperFunction";
import { debounce } from "@mui/material";
import { initFinancialStatusCount } from "mocks/grData";
import { getAllNewGr } from "../../redux/handlers/logic/getAllNewGr.handler";
export default function useInitGrReviewDataList(param) {
    var initStatus = param.initStatus;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState([]), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState2[0], setPageModel = _useState2[1];
    var _useState3 = _sliced_to_array(useState(initStatus), 2), btnempstatus = _useState3[0], setBtnempstatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState4[0], setSelectedGroupOfSuplierID = _useState4[1];
    var _useState5 = _sliced_to_array(useState(initFinancialStatusCount), 2), financialStatusCount = _useState5[0], setFinancialStatusCount = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    // Reducers
    var reducers = {
        getAllNewGr: useAppSelector(function(state) {
            return state.getAllNewGrReducer;
        })
    };
    var isInitGrLoading = useMemo(function() {
        return reducers.getAllNewGr.isFetching;
    }, [
        reducers.getAllNewGr.isFetching
    ]);
    var getData = useCallback(function(page, limit, searchText, groupSubID, financialStatusID) {
        var modifyFinanStatusID = financialStatusID === 1 ? null : financialStatusID;
        var queryParams = {
            mstNewStatusID: 6,
            financialStatusID: modifyFinanStatusID,
            page: page || pageModel.page,
            limit: limit || pageModel.pageSize,
            searchText: searchText,
            groupSubID: groupSubID || ""
        };
        dispatch(getAllNewGr({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        getData(1, pageModel.pageSize, "", "", btnempstatus);
    }, []);
    useEffect(function() {
        if (reducers.getAllNewGr.data) {
            var result = reducers.getAllNewGr.data.data.data;
            var meta = reducers.getAllNewGr.data.data.meta;
            var financialStatusCount = reducers.getAllNewGr.data.data.financialStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            // console.log(result)
            setTab(result);
            setFinancialStatusCount(financialStatusCount);
        }
    }, [
        reducers.getAllNewGr.data
    ]);
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus);
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus);
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    return {
        pageModel: pageModel,
        setPageModel: setPageModel,
        filterText: filterText,
        setFilterText: setFilterText,
        data: data,
        setData: setData,
        btnempstatus: btnempstatus,
        setBtnempstatus: setBtnempstatus,
        getData: getData,
        financialStatusCount: financialStatusCount,
        isInitGrLoading: isInitGrLoading,
        selectedGroupOfSuplierID: selectedGroupOfSuplierID,
        setSelectedGroupOfSuplierID: setSelectedGroupOfSuplierID,
        setFinancialStatusCount: setFinancialStatusCount
    };
}
